module.exports = __webpack_public_path__ + "img/download-brocher.2103f6ce.gif";